import stationDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0
  }
};

const stationReducer = stationDispatcher(initialState, {
  [stationDispatcher.getStationsSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined
    }
  }),
  [stationDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value
  })
});

export default stationReducer;
